// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-stepper{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .container-steps{
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
    justify-content: center;
    margin: 10px auto;

  }

  .circle{
    border-radius: 50%;
    background-color: var(--form-background);
    height: 18px;
    width: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .circle-branco{
    border-radius: 50%;
    background-color: transparent;
    border: 1px solid var(--filter);
    height: 18px;
    width: 18px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .arrow-left{
    margin-top: 10px;
    margin-right: 2px;
  }

  .arrow-right{
    margin-top: 10px;
    margin-left: 2px;
  }

  .text-step{
    font-size: 12px;
    color: var(--text);
  }

  .text-intervention{
    font-size: 14px;
    font-weight: 500;
    color: var(--filter);
    margin-bottom: 20px;
  }

  .intervention-selected{
    background-color: var(--primary-background) !important;
  }

  .circle-disable{
    border-radius: 50%;
    background-color: transparent;
    border: 1px solid var(--form-background) !important;
    height: 18px;
    width: 18px;
    display: flex;
    align-items: center;
    cursor: default;
  }

  .arrow-disable{
    opacity: 20%;
  }
`, "",{"version":3,"sources":["webpack://./src/app/shared/stepper/stepper.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;;EAEnB;;EAEA;IACE,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,+BAA+B;IAC/B,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,sDAAsD;EACxD;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,mDAAmD;IACnD,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd","sourcesContent":[".container-stepper{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .container-steps{\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    align-items: center;\n    justify-content: center;\n    margin: 10px auto;\n\n  }\n\n  .circle{\n    border-radius: 50%;\n    background-color: var(--form-background);\n    height: 18px;\n    width: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n  }\n\n  .circle-branco{\n    border-radius: 50%;\n    background-color: transparent;\n    border: 1px solid var(--filter);\n    height: 18px;\n    width: 18px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n  }\n\n  .arrow-left{\n    margin-top: 10px;\n    margin-right: 2px;\n  }\n\n  .arrow-right{\n    margin-top: 10px;\n    margin-left: 2px;\n  }\n\n  .text-step{\n    font-size: 12px;\n    color: var(--text);\n  }\n\n  .text-intervention{\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--filter);\n    margin-bottom: 20px;\n  }\n\n  .intervention-selected{\n    background-color: var(--primary-background) !important;\n  }\n\n  .circle-disable{\n    border-radius: 50%;\n    background-color: transparent;\n    border: 1px solid var(--form-background) !important;\n    height: 18px;\n    width: 18px;\n    display: flex;\n    align-items: center;\n    cursor: default;\n  }\n\n  .arrow-disable{\n    opacity: 20%;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
